import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroSection() {
  const featured = comics.slice(0, 3);

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20illustration%20with%20soft%20flowing%20curves%20in%20coral%20pink%20and%20cream%20tones%2C%20minimalist%20clean%20design%2C%20gentle%20gradients%2C%20light%20airy%20atmosphere%2C%20subtle%20texture%2C%20suitable%20for%20a%20manga%20reading%20website%20hero%20background%2C%20no%20text&width=1600&height=900&seq=hero-bg-manga&orientation=landscape"
          alt="奇妙漫画网"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-screen-2xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
              发现属于你的
              <br />
              <span className="text-primary-300">韩国漫画世界</span>
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              免费韩漫在线阅读平台，汇集恋爱、奇幻、动作、悬疑等各类好看韩国漫画。
              每日更新，个性化推荐，流畅阅读体验，带你进入奇妙的漫画之旅。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/category/all"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
              >
                开始阅读
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>

            <div className="flex items-center gap-8 mt-10 justify-center lg:justify-start">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">10,000+</div>
                <div className="text-xs md:text-sm text-white/60 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">500万+</div>
                <div className="text-xs md:text-sm text-white/60 mt-1">月活跃用户</div>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">99.7%</div>
                <div className="text-xs md:text-sm text-white/60 mt-1">用户好评率</div>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-4">
            {featured.map((comic, idx) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className={`flex-shrink-0 rounded-xl overflow-hidden transition-transform duration-300 hover:scale-105 hover:-translate-y-2 ${
                  idx === 1 ? 'w-44 h-60 shadow-lg' : 'w-36 h-48 opacity-80'
                }`}
              >
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}